// Studyo Today Backend
// Package studyo.today.sel.v1.resources
// Resource definitions
// Copyright (c) 2015-2022 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/sel/v1/resources/emotional_pulse.proto (package studyo.today.sel.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_type_date } from "@buf/googleapis_googleapis.bufbuild_es/google/type/date_pb.js";

/**
 * Describes the file studyo/today/sel/v1/resources/emotional_pulse.proto.
 */
export const file_studyo_today_sel_v1_resources_emotional_pulse = /*@__PURE__*/
  fileDesc("CjNzdHVkeW8vdG9kYXkvc2VsL3YxL3Jlc291cmNlcy9lbW90aW9uYWxfcHVsc2UucHJvdG8SHXN0dWR5by50b2RheS5zZWwudjEucmVzb3VyY2VzIosBCg5FbW90aW9uYWxQdWxzZRIPCgd1c2VyX2lkGAEgASgJEg4KBnJhdGluZxgCIAEoBRItCgl0aW1lc3RhbXAYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEikKDnN1Ym1pdHRlcl9kYXRlGAQgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUIlqgIiU3R1ZHlvLlRvZGF5LlNlbC5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_google_protobuf_timestamp, file_google_type_date]);

/**
 * Describes the message studyo.today.sel.v1.resources.EmotionalPulse.
 * Use `create(EmotionalPulseSchema)` to create a new message.
 */
export const EmotionalPulseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_sel_v1_resources_emotional_pulse, 0);

